import { createContext, useContext } from 'react';

const Context = createContext(false);

export const IsCustomBackgroundActiveContextProvider = Context.Provider;

export function useIsCustomBackgroundActive(): boolean {
  return useContext(Context);
}
